import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { axiosInstance, BASE_URL } from "../../Config";

const ViewUser = () => {
  const { id } = useParams();
  const [error, setError] = useState("");
  const [user, setUser] = useState({});
  const [detail, setDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUser();
  }, [id]);

  const fetchUser = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`/getUser/${id}`);
      if (res.data && res.data.body) {
        setUser(res.data.body);
        setDetail(res.data.body.userDetail);
        setError("");
      } else {
        setUser({});
        setError("User not found");
      }
    } catch (error) {
      setUser({});
      setDetail({});
      setError(error.response?.data?.message || "Error fetching user details");
    } finally {
      setLoading(false);
    }
  };

  const getGenderText = (gender) => {
    if (gender === 0) return "Men";
    if (gender === 1) return "Women";
    if (gender === 2) return "Open to all";
    return "N/A";
  };

  const getMyGenderText = (gender) => {
    if (gender === 0) return "Man";
    if (gender === 1) return "Woman";
    if (gender === 2) return "LGBT";
    return "N/A";
  };

  const getSexuality = (val) => {
    if (val === 0) return "Gay";
    if (val === 1) return "Straight";
    if (val === 2) return "Lesbian";
    if (val === 3) return "Biesexual";
    if (val === 4) return "Open to All";
    return "N/A";
  };

  const getLivingSituation = (val) => {
    if (val === 0) return "Move In With Me";
    if (val === 1) return "Move In With Them";
    if (val === 2) return "Get A Place Together";
    if (val === 3) return "Figure It Out Together";
    if (val === 4) return "Open to All";
    return "N/A";
  };

  const getIntention = (intention) => {
    if (intention === 0) return "No";
    if (intention === 1) return "Yes";
    if (intention === 2) return "Open to All";
    return "N/A";
  };

  const getBodyType = (type) => {
    if (type == 0) return "Slender/Thin";
    if (type == 1) return "Athletic/Toned";
    if (type == 2) return "Average";
    if (type == 3) return "Curvy/Husky";
    if (type == 4) return "Plus Size";
    if (type == 5) return "Other";
    return "N/A";
  };
  const getPets = (type) => {
    if (type === 0) return "None";
    if (type === 1) return "Dog(s)";
    if (type === 2) return "Cat(s)";
    if (type === 3) return "Other";
    if (type === 4) return "Open to All";
    return "N/A";
  };

  const getChildrenLive = (type) => {
    if (type === 0) return "Live with me";
    if (type === 1) return "Live with other parent";
    if (type === 2) return "Split Custody";
    if (type === 3) return "Live Independently";
    return "N/A";
  };

  const getChildrenQuery = (type) => {
    if (type === 0) return "Has Children";
    if (type === 1) return "Wants Children";
    if (type === 2) return "Doesn't want children";
    if (type === 3) return "Open to All";
    return "N/A";
  };

  const getPoliticalView = (type, isPreference = 0) => {
    if (type === 0) return "Liberal";
    if (type === 1) return "Conservative";
    if (type === 2) return "Moderate";
    if (type === 3 && isPreference == 0) {
      return "Other";
    } else if (type === 3 && isPreference == 1) {
      return "Open To All";
    }
    if (type === 4) return "Prefer Not To Say";
    return user && user.is_profile_completed == 1 ? "Prefer Not To Say" : "N/A";
  };

  const getHabbit = (type) => {
    if (type === 0) return "Yes";
    if (type === 1) return "No";
    if (type === 2) return "Sometimes";
    if (type === 3) return "Socially";
    if (type === 4) return "Regularly";
    if (type === 5) return "Open to All";
    return "N/A";
  };

  const getMarijuanaDrugs = (type) => {
    if (type === 0) return "Yes";
    if (type === 1) return "No";
    if (type === 2) return "Sometimes";
    if (type === 3) return "Socially";
    if (type === 4) return "Open to All";
    return "N/A";
  };

  const getRelationship = (type) => {
    if (type === 0) return "Single";
    if (type === 1) return "Divorced";
    if (type === 2) return "Separated";
    if (type === 3) return "Widowed";
    if (type === 4) return "Open to All";
    return "N/A";
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;

    const [day, month, year] = dateString.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  const calculateAge = (dateString) => {
    if (!dateString) return "N/A";

    const birthDate = parseDate(dateString);
    if (!birthDate || isNaN(birthDate)) return "N/A";

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = parseDate(dateString);
    if (!date || isNaN(date)) return "N/A";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatIncome = (start, end) => {
    if (Number(start) === 0 && end) {
      return `Less than $${Number(end).toLocaleString()}`;
    }
    if (start && !end) {
      return `$${Number(start).toLocaleString()}+`;
    }
    if (start && end) {
      return `$${Number(start).toLocaleString()} - $${Number(end).toLocaleString()}`;
    }
    return user && user.is_profile_completed == 1 ? "Prefer Not To Say" : "N/A";
  };

  const mainUserImage = user?.userImages?.find(
    (item) => item?.mainImage && item.mainImage.trim() !== "",
  )?.mainImage;

  const otherUserImages =
    user?.userImages?.filter(
      (item) => item?.image && item.image.trim() !== "",
    ) || [];

  if (loading) {
    return (
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="title-box mb-3 pb-1">
                <h4 className="mb-0 page-title">User Details</h4>
                <nav aria-label="breadcrumb" className="mt-1">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard" className="new">
                        <i className="ri-home-4-fill me-1" /> Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/userlist" className="new">
                        Users
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      View User
                    </li>
                  </ol>
                </nav>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}

                      {user && Object.keys(user).length > 0 ? (
                        <div className="user-details">
                          <div className="text-center mb-4">
                            {user?.image ? (
                              <a
                                href={`${BASE_URL}${user?.image}`}
                                data-fancybox="user-gallery"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={`${BASE_URL}${user?.image}`}
                                  alt={user?.name || "User"}
                                  style={{
                                    width: "150px",
                                    height: "150px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    border: "3px solid #f0f0f0",
                                    cursor: "pointer",
                                  }}
                                />
                              </a>
                            ) : (
                              <img
                                src={"/assets/images/user.png"}
                                alt={"User"}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "1px solid #f0f0f0",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Name
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.name || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Email Address
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.email || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Phone Number
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.country_code || "N/A"}{" "}
                                {user?.phone_number || ""}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Date of Birth
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.dob ? user?.dob : "N/A"}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Age
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user.dob ? calculateAge(user?.dob) : "N/A"}
                              </div>
                            </div>

                            {user?.bio && (
                              <div className="col-12 mb-3">
                                <label className="fw-bold text-muted mb-1">
                                  Bio
                                </label>
                                <div className="p-2 bg-light rounded">
                                  {user?.bio}
                                </div>
                              </div>
                            )}
                          </div>

                          {user?.answers_given &&
                            user.answers_given.length > 0 && (
                              <div className="col-12 mb-3">
                                <label className="fw-bold text-muted mb-2">
                                  Questions & Answers
                                </label>

                                <div className="border rounded p-3">
                                  {user.answers_given.map((item, index) => (
                                    <div
                                      key={item.id || index}
                                      className={`pb-3 ${
                                        index !== user.answers_given.length - 1
                                          ? "mb-3 border-bottom"
                                          : ""
                                      }`}
                                    >
                                      <div className="fw-bold mb-1">
                                       Q {index + 1}. {item.question || "N/A"}
                                      </div>

                                      <div className="text-muted">
                                        Ans: {item.answer || "N/A"}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          <div className="row">
                            <h3>User's Additional Details</h3>

                            <div className="col-12 mb-4">
                              <label className="fw-bold text-muted mb-2 d-block text-center">
                                User Images
                              </label>

                              {/* Main Image */}
                              <div className="text-center mb-3">
                                {mainUserImage ? (
                                  <a
                                    href={`${BASE_URL}${mainUserImage}`}
                                    data-fancybox="user-gallery"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={`${BASE_URL}${mainUserImage}`}
                                      alt="Main User"
                                      style={{
                                        width: "180px",
                                        height: "180px",
                                        borderRadius: "12px",
                                        objectFit: "cover",
                                        border: "3px solid #f0f0f0",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </a>
                                ) : (
                                  <img
                                    src={"/assets/images/user.png"}
                                    alt="User"
                                    style={{
                                      width: "120px",
                                      height: "120px",
                                      borderRadius: "12px",
                                      objectFit: "cover",
                                      border: "1px solid #f0f0f0",
                                    }}
                                  />
                                )}
                              </div>

                              {/* Other Images */}
                              {otherUserImages.length > 0 && (
                                <div className="row">
                                  {otherUserImages.map((img, index) => (
                                    <div
                                      className="col-md-3 col-sm-4 col-6 mb-3"
                                      key={img.id || index}
                                    >
                                      <a
                                        href={`${BASE_URL}${img.image}`}
                                        data-fancybox="user-gallery"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src={`${BASE_URL}${img.image}`}
                                          alt={`User ${index + 1}`}
                                          style={{
                                            width: "100%",
                                            height: "140px",
                                            borderRadius: "10px",
                                            objectFit: "cover",
                                            border: "1px solid #e5e5e5",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </a>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Gender
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getMyGenderText(detail?.gender)}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Location
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.location || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Height
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.height !== null &&
                                detail?.height !== undefined
                                  ? Number.isInteger(Number(detail.height))
                                    ? Number(detail.height).toFixed(1) // 6 → 6.0
                                    : detail.height // 6.11 → 6.11
                                  : ""}
                                {detail?.height_type
                                  ? detail?.height_type == 1
                                    ? " Feet."
                                    : detail?.height_type == 2
                                      ? " Inches"
                                      : "N/A"
                                  : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Sexuality
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getSexuality(detail?.sexuality)}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Ethnicity
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.user_ethnicity
                                  ? detail?.user_ethnicity?.name
                                  : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Body Type
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getBodyType(detail?.body_type) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Religious Belief
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.userReligion?.name || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Marital Status
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getRelationship(
                                  detail?.relationship_history,
                                ) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Do you have children?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.have_children == 1
                                  ? "Yes"
                                  : detail?.have_children == 0
                                    ? "No"
                                    : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Where do your children live?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getChildrenLive(detail?.children_live) ||
                                  "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Do you want children in future?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.children_in_future == 1
                                  ? "Yes"
                                  : detail?.children_in_future == 0
                                    ? "No"
                                    : detail?.children_in_future == 2
                                      ? "Not Sure"
                                      : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Hobbies And Interests
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.userHobbie?.name || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Other Hobbies
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.other_hobbies || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Education Level
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.userEducation?.name || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Occupation
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.occupation || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Annual Income
                              </label>
                              <div className="p-2 bg-light rounded">
                                {formatIncome(
                                  detail?.userIncome?.start,
                                  detail?.userIncome?.end,
                                )}
                              </div>
                            </div>

                            {/* <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Citizenship Status
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.userCitizenship?.name ||
                                  "Prefer Not To Say"}
                              </div>
                            </div> */}

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Home Town
                              </label>
                              <div className="p-2 bg-light rounded">
                                {detail?.home_town ||
                                (user && user.is_profile_completed == 1)
                                  ? "Prefer Not To Say"
                                  : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Political
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getPoliticalView(detail?.political_view) ||
                                  "Prefer Not To Say"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Drinking?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getHabbit(detail?.drink_alcohol) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Smoking?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getHabbit(detail?.smoke_cigrattes) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Marijuana?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getHabbit(detail?.marijuana) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Drugs?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getHabbit(detail?.drugs) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Are you open to a prenuptial agreement?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getIntention(detail?.prenuptial_agrement) ||
                                  "N/A"}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Would you be interested in MMM prenuptial
                                service?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getIntention(detail?.mmm_prenuptial_service) ||
                                  "N/A"}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <h3>User Preferences</h3>
                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Gender
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getGenderText(user?.userPreferences?.gender)}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Height Range
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences?.height_open_to_all == 1
                                  ? "Open to All"
                                  : (() => {
                                      const min =
                                        user?.userPreferences?.min_height;
                                      const max =
                                        user?.userPreferences?.max_height;
                                      const type =
                                        user?.userPreferences?.height_type;

                                      const unit =
                                        type == 1
                                          ? "Feets."
                                          : type == 2
                                            ? "Inches"
                                            : "";

                                      const formatHeight = (val) => {
                                        if (val === null || val === undefined)
                                          return "";
                                        return Number(val) % 1 === 0
                                          ? Number(val).toFixed(1)
                                          : val;
                                      };

                                      if (!min && !max) return "N/A";

                                      if (min && max) {
                                        return `${formatHeight(min)} - ${formatHeight(max)} ${unit}`;
                                      }

                                      return `${formatHeight(min || max)} ${unit}`;
                                    })()}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Sexuality
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getSexuality(user?.userPreferences?.sexuality)}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Ethnicity
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences?.ethnicity_open_to_all ==
                                1
                                  ? "Open to All"
                                  : user?.userPreferenceEthnicity?.length > 0
                                    ? user.userPreferenceEthnicity
                                        .map((e) => e.parentEthnicity?.name)
                                        .filter(Boolean)
                                        .join(", ")
                                    : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Body Type
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences?.body_type_open_to_all ==
                                1
                                  ? "Open to All"
                                  : user?.preferred_body_types?.length > 0
                                    ? user.preferred_body_types
                                        .map((e) => getBodyType(e.body_type))
                                        .filter(Boolean)
                                        .join(", ")
                                    : "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Religious Beliefs
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences
                                  ?.religious_belief_open_to_all == 1
                                  ? "Open to All"
                                  : user?.preferred_religious_beliefs?.length >
                                      0
                                    ? user.preferred_religious_beliefs
                                        .map(
                                          (e) =>
                                            e.parent_religious_belief?.name,
                                        )
                                        .filter(Boolean)
                                        .join(", ")
                                    : "N/A"}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Marital Status
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getRelationship(
                                  user?.userPreferences?.marital_status,
                                ) || "N/A"}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Children
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getChildrenQuery(
                                  user?.userPreferences?.children,
                                ) || "N/A"}
                              </div>
                            </div>
                            {/* <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Citizenship Status
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences
                                  ?.citizenship_open_to_all == 1
                                  ? "Open to All"
                                  : user?.userPreferences
                                      ?.userPreferenceCitizenship?.name ||
                                    "N/A"}
                              </div>
                            </div> */}
                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Home Town
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences?.home_town == null
                                  ? user && user.is_profile_completed == 1
                                    ? "Open to All"
                                    : "N/A"
                                  : user?.userPreferences?.home_town || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Education Level
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences
                                  ?.education_level_open_to_all == 1
                                  ? "Open to All"
                                  : user?.userPreferences
                                      ?.userPreferenceEducation?.name || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Annual Income
                              </label>
                              <div className="p-2 bg-light rounded">
                                {user?.userPreferences?.income_open_to_all == 1
                                  ? "Open to All"
                                  : formatIncome(
                                      user?.userPreferences
                                        ?.userPreferenceIncome?.start,
                                      user?.userPreferences
                                        ?.userPreferenceIncome?.end,
                                    )}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Political View
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getPoliticalView(detail?.political_view, 1) ||
                                  "Prefer Not To Say"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Preferred Pets
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getPets(user?.userPreferences?.pets) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Drinking?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getHabbit(
                                  user?.userPreferences?.drink_alcohol,
                                ) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Smoking?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getHabbit(
                                  user?.userPreferences?.smoke_cigrattes,
                                ) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Marijuana?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getMarijuanaDrugs(
                                  user?.userPreferences?.marijuana,
                                ) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Drugs?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getMarijuanaDrugs(
                                  user?.userPreferences?.drugs,
                                ) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Prenuptial?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getIntention(
                                  user?.userPreferences?.prenuptial_agrement,
                                ) || "N/A"}
                              </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-3">
                              <label className="fw-bold text-muted mb-1">
                                Living Situation?
                              </label>
                              <div className="p-2 bg-light rounded">
                                {getLivingSituation(
                                  user?.userPreferences?.living_situation,
                                ) || "N/A"}
                              </div>
                            </div>
                          </div>

                          <div className="text-end mt-4">
                            <button
                              type="button"
                              className="btn btn-secondary me-2 px-4"
                              onClick={() => navigate("/userlist")}
                            >
                              Back
                            </button>
                          </div>
                        </div>
                      ) : (
                        !error && (
                          <div className="text-center py-4">
                            <p>No user details found</p>
                            <button
                              type="button"
                              className="btn btn-secondary mt-3"
                              onClick={() => navigate("/userlist")}
                            >
                              Back to List
                            </button>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewUser;
